import { render, staticRenderFns } from "./LocalSheet.vue?vue&type=template&id=5732a417&scoped=true&"
import script from "./LocalSheet.vue?vue&type=script&lang=js&"
export * from "./LocalSheet.vue?vue&type=script&lang=js&"
import style0 from "./LocalSheet.vue?vue&type=style&index=0&id=5732a417&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5732a417",
  null
  
)

export default component.exports